import { WEATHER_DETAIL_ICON_KEYS } from 'features/Weather/config/weatherDetailIcons.config';
import { displayMarineValue } from '../../../utils/marineForecast.utils';

export const route = 'getDetailedMarine7';

export const surfAlertDetails = [
  {
    id: 'wave',
    label: 'Wave',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WAVE,
    getValue: (entry) => displayMarineValue(entry?.wave),
  },
  {
    id: 'wind',
    label: 'Wind',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WIND_SPEED,
    getValue: (entry) => displayMarineValue(entry?.wind),
  },
];
